export function safeJSONParse<T>(json: string): T | undefined {
  try {
    return JSON.parse(json) as T;
  } catch (error) {
    console.error('safeJSONParse', error);
    return undefined;
  }
}
